import clientService from 'src/clientService';

// A clip row carries its own signed url; an uploaded-but-unanalysed row only carries a
// file id, so its audio comes from the download-url route.

export interface AudioSource {
  fileId?: string;
  clipData?: { url?: string } | null;
}

export const resolveAudioUrl = async (source: AudioSource): Promise<string | null> => {
  const clipUrl = source.clipData?.url;
  if (clipUrl) return clipUrl;
  if (!source.fileId) return null;

  const response =
    await clientService.api.getDownloadUrlApiV1AdminFilesFileIdDownloadUrlGet(source.fileId);
  return response.data.download_url || null;
};
